import OnboardingTitleGradient from './OnboardingTitleGradient'

export default OnboardingTitleGradient
// eslint-disable-next-line import/export
export * from './OnboardingTitleGradient'
